module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner-onlinesupport@2x-5cc59d597b8e561e6adf8e018a587a64.webp";